import nlp from 'compromise';

// ─────────────────────────────────────────────────────────────
// colivingNaturalLanguageParser.js
// Parser de lenguaje natural especializado en búsqueda de colivings
// Reutiliza la base de naturalLanguageParser.js pero adaptado
// a los filtros de ColivingAdvancedSearch
// ─────────────────────────────────────────────────────────────

nlp.extend((_Doc, world) => {
  world.addWords({
    // ── Ciudades ES ──
    madrid: 'ColivingLocation',
    barcelona: 'ColivingLocation',
    valencia: 'ColivingLocation',
    sevilla: 'ColivingLocation',
    málaga: 'ColivingLocation',
    malaga: 'ColivingLocation',
    bilbao: 'ColivingLocation',
    salamanca: 'ColivingLocation',
    alicante: 'ColivingLocation',
    granada: 'ColivingLocation',
    pamplona: 'ColivingLocation',
    getafe: 'ColivingLocation',
    alcobendas: 'ColivingLocation',
    tenerife: 'ColivingLocation',
    'las palmas': 'ColivingLocation',
    canarias: 'ColivingLocation',
    'islas canarias': 'ColivingLocation',
    'gran canaria': 'ColivingLocation',
    // ── Ciudades US ──
    'new york': 'ColivingLocation',
    nyc: 'ColivingLocation',
    manhattan: 'ColivingLocation',
    brooklyn: 'ColivingLocation',
    'los angeles': 'ColivingLocation',
    la: 'ColivingLocation',
    'san francisco': 'ColivingLocation',
    chicago: 'ColivingLocation',
    miami: 'ColivingLocation',
    austin: 'ColivingLocation',
    seattle: 'ColivingLocation',
    boston: 'ColivingLocation',
    denver: 'ColivingLocation',
    washington: 'ColivingLocation',
    houston: 'ColivingLocation',
    atlanta: 'ColivingLocation',
    // ── Ciudades UK ──
    london: 'ColivingLocation',
    manchester: 'ColivingLocation',
    edinburgh: 'ColivingLocation',
    birmingham: 'ColivingLocation',
    bristol: 'ColivingLocation',
    leeds: 'ColivingLocation',
    liverpool: 'ColivingLocation',
    glasgow: 'ColivingLocation',
    oxford: 'ColivingLocation',
    cambridge: 'ColivingLocation',

    // ── Políticas ──
    mascotas: 'ColivingPolicy',
    mascota: 'ColivingPolicy',
    perro: 'ColivingPolicy',
    perros: 'ColivingPolicy',
    gato: 'ColivingPolicy',
    gatos: 'ColivingPolicy',
    animal: 'ColivingPolicy',
    animales: 'ColivingPolicy',
    parejas: 'ColivingPolicy',
    pareja: 'ColivingPolicy',
    pets: 'ColivingPolicy',
    couples: 'ColivingPolicy',

    // ── Estudiantes / Nómadas ──
    estudiante: 'ColivingAudience',
    estudiantes: 'ColivingAudience',
    erasmus: 'ColivingAudience',
    universitario: 'ColivingAudience',
    universitarios: 'ColivingAudience',
    nómada: 'ColivingAudience',
    nómadas: 'ColivingAudience',
    nomada: 'ColivingAudience',
    nomadas: 'ColivingAudience',
    'nómada digital': 'ColivingAudience',
    'nómadas digitales': 'ColivingAudience',
    student: 'ColivingAudience',
    students: 'ColivingAudience',
    'digital nomad': 'ColivingAudience',
    'digital nomads': 'ColivingAudience',
    nomads: 'ColivingAudience',
    'remote worker': 'ColivingAudience',
    'remote workers': 'ColivingAudience',
    freelancer: 'ColivingAudience',
    freelancers: 'ColivingAudience',

    // ── Servicios ──
    wifi: 'ColivingService',
    internet: 'ColivingService',
    fibra: 'ColivingService',
    limpieza: 'ColivingService',
    cleaning: 'ColivingService',
    'todo incluido': 'ColivingService',
    'gastos incluidos': 'ColivingService',
    'all included': 'ColivingService',
    'all inclusive': 'ColivingService',

    // ── Tipo de alojamiento ──
    edificio: 'AccommodationType',
    residencia: 'AccommodationType',
    'piso compartido': 'AccommodationType',
    'apartamento compartido': 'AccommodationType',
    apartment: 'AccommodationType',
    building: 'AccommodationType',

    // ── Duración ──
    'corta estancia': 'StayDuration',
    'larga estancia': 'StayDuration',
    temporal: 'StayDuration',
    'short stay': 'StayDuration',
    'long stay': 'StayDuration',

    // ── Proveedores (top) ──
    'urban campus': 'ColivingProvider',
    habyt: 'ColivingProvider',
    muppy: 'ColivingProvider',
    kanso: 'ColivingProvider',
    'enso coliving': 'ColivingProvider',
    enso: 'ColivingProvider',
    homiii: 'ColivingProvider',
    spacest: 'ColivingProvider',
    aticco: 'ColivingProvider',
    haaus: 'ColivingProvider',
    socien: 'ColivingProvider',
    suiters: 'ColivingProvider',
    houxury: 'ColivingProvider',
    colivinn: 'ColivingProvider',
    flipco: 'ColivingProvider',
    'live it': 'ColivingProvider',
    smartrental: 'ColivingProvider',
    queens: 'ColivingProvider',
    'social hub': 'ColivingProvider',
    'the social hub': 'ColivingProvider',
    outsite: 'ColivingProvider',
    resa: 'ColivingProvider',
    yugo: 'ColivingProvider',
    livensa: 'ColivingProvider',
    collegiate: 'ColivingProvider',
    flaternity: 'ColivingProvider',
    hive: 'ColivingProvider',
    'grupo hive': 'ColivingProvider',
    nomad: 'ColivingProvider',
    'nomad flex': 'ColivingProvider',
    repeople: 'ColivingProvider',
    maraya: 'ColivingProvider',
    'far home': 'ColivingProvider',
    'node living': 'ColivingProvider',
    trees: 'ColivingProvider',
    'gaiastays': 'ColivingProvider',
    'gaia stays': 'ColivingProvider',
    'mycoliving': 'ColivingProvider',
    'trc': 'ColivingProvider',
    'the residential club': 'ColivingProvider',
  });
});

// ── Mapa de palabras numéricas ──
const numberWordsMap = {
  un: 1, una: 1, uno: 1,
  dos: 2, tres: 3, cuatro: 4, cinco: 5,
  seis: 6, siete: 7, ocho: 8, nueve: 9,
  diez: 10, once: 11, doce: 12,
  medio: 6, // "medio año"
};

function parseNumberWord(word) {
  const lower = word.toLowerCase().trim();
  if (numberWordsMap[lower] !== undefined) return numberWordsMap[lower];
  const num = parseInt(lower, 10);
  return isNaN(num) ? undefined : num;
}

// ── Ciudades disponibles (debe coincidir con availableLocations) ──
const availableLocationsMap = {
  // España
  madrid: 'Madrid',
  barcelona: 'Barcelona',
  valencia: 'Valencia',
  sevilla: 'Sevilla',
  málaga: 'Málaga',
  malaga: 'Málaga',
  bilbao: 'Bilbao',
  salamanca: 'Salamanca',
  alicante: 'Alicante',
  granada: 'Granada',
  pamplona: 'Pamplona',
  getafe: 'Getafe',
  alcobendas: 'Alcobendas',
  tenerife: 'Tenerife',
  'las palmas': 'Las Palmas',
  'gran canaria': 'Las Palmas',
  'santa cruz de tenerife': 'Tenerife',
  'santa cruz': 'Tenerife',
  // US
  'new york': 'New York',
  'new york city': 'New York',
  nyc: 'New York',
  manhattan: 'New York',
  brooklyn: 'New York',
  'los angeles': 'Los Angeles',
  'san francisco': 'San Francisco',
  'sf': 'San Francisco',
  chicago: 'Chicago',
  miami: 'Miami',
  austin: 'Austin',
  seattle: 'Seattle',
  boston: 'Boston',
  denver: 'Denver',
  washington: 'Washington',
  'washington dc': 'Washington',
  houston: 'Houston',
  atlanta: 'Atlanta',
  // UK
  london: 'London',
  manchester: 'Manchester',
  edinburgh: 'Edinburgh',
  birmingham: 'Birmingham',
  bristol: 'Bristol',
  leeds: 'Leeds',
  liverpool: 'Liverpool',
  glasgow: 'Glasgow',
  oxford: 'Oxford',
  cambridge: 'Cambridge',
};

// ── Alias que expanden a MÚLTIPLES ciudades simultáneamente ──
const multiLocationAliases = {
  canarias: ['Las Palmas', 'Tenerife'],
  'islas canarias': ['Las Palmas', 'Tenerife'],
};

// ── Proveedores: texto → id ──
const providerMap = {
  'urban campus': 'urbancampus',
  habyt: 'habyt',
  muppy: 'muppy',
  kanso: 'kanso',
  'enso coliving': 'enso',
  enso: 'enso',
  homiii: 'homiii',
  spacest: 'spacest',
  aticco: 'aticco',
  haaus: 'haaus',
  socien: 'socien',
  suiters: 'suiters',
  houxury: 'houxury',
  colivinn: 'colivinn',
  flipco: 'flipco',
  'live it': 'liveit',
  smartrental: 'liveit',
  queens: 'queens',
  'social hub': 'socialhub',
  'the social hub': 'socialhub',
  outsite: 'outsite',
  resa: 'resa',
  yugo: 'yugo',
  livensa: 'livensa',
  collegiate: 'collegiate',
  flaternity: 'flaternity',
  hive: 'hive',
  'grupo hive': 'hive',
  nomad: 'nomad',
  'nomad flex': 'nomad',
  repeople: 'repeople',
  maraya: 'maraya',
  'far home': 'farhome',
  'node living': 'node',
  trees: 'trees',
  gaiastays: 'gaiastays',
  'gaia stays': 'gaiastays',
  mycoliving: 'mycoliving',
  trc: 'trc',
  'the residential club': 'trc',
};

// ── Distancia de Levenshtein (para tolerancia a errores) ──
function levenshtein(a, b) {
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;
  const matrix = [];
  for (let i = 0; i <= b.length; i++) matrix[i] = [i];
  for (let j = 0; j <= a.length; j++) matrix[0][j] = j;
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      const cost = b.charAt(i - 1) === a.charAt(j - 1) ? 0 : 1;
      matrix[i][j] = Math.min(
        matrix[i - 1][j - 1] + cost,
        matrix[i][j - 1] + 1,
        matrix[i - 1][j] + 1
      );
    }
  }
  return matrix[b.length][a.length];
}

// ═══════════════════════════════════════════════════════════════
// FUNCIÓN PRINCIPAL
// ═══════════════════════════════════════════════════════════════

/**
 * Parsea lenguaje natural y devuelve filtros de coliving.
 * @param {string} text - Texto del usuario
 * @param {object|null} userPreferences - Preferencias del usuario logueado
 *   { preferredCity, isStudent, monthlyIncome }
 * @returns {object} Filtros detectados
 */
export function parseColivingNaturalLanguage(text, userPreferences = null) {
  const lowerText = text.toLowerCase().trim();
  const doc = nlp(lowerText);

  const filters = {
    locations: extractLocations(doc, lowerText),
    maxPrice: extractMaxPrice(lowerText),
    maxMinimumStay: extractStayDuration(doc, lowerText),
    policies: extractPolicies(doc, lowerText),
    services: extractServices(doc, lowerText),
    minBathrooms: extractBathrooms(doc, lowerText),
    accommodationType: extractAccommodationType(doc, lowerText),
    forStudents: extractStudentFilter(doc, lowerText),
    forNomads: extractNomadFilter(doc, lowerText),
    providers: extractProviders(lowerText),
  };

  // ── Enriquecer con preferencias del usuario autenticado ──
  if (userPreferences) {
    // Si no ha mencionado ciudad pero tiene preferencia guardada
    if (filters.locations.length === 0 && userPreferences.preferredCity) {
      const mapped = availableLocationsMap[userPreferences.preferredCity.toLowerCase()];
      if (mapped) {
        filters.locations = [mapped];
        filters._usedPreference = filters._usedPreference || [];
        filters._usedPreference.push('preferredCity');
      }
    }

    // Si no ha mencionado presupuesto pero tiene income
    if (!filters.maxPrice && userPreferences.monthlyIncome) {
      // Sugerir ~40-50% del income como max
      const suggestedMax = Math.round(userPreferences.monthlyIncome * 0.45 / 50) * 50;
      if (suggestedMax >= 200) {
        filters.maxPrice = suggestedMax;
        filters._usedPreference = filters._usedPreference || [];
        filters._usedPreference.push('monthlyIncome');
      }
    }

    // Si es estudiante
    if (userPreferences.isStudent && !filters.forStudents) {
      filters.forStudents = true;
      filters._usedPreference = filters._usedPreference || [];
      filters._usedPreference.push('isStudent');
    }
  }

  // Limpiar campos vacíos / nulos / false
  cleanFilters(filters);

  return filters;
}

// ═══════════════════════════════════════════════════════════════
// FUNCIONES DE EXTRACCIÓN
// ═══════════════════════════════════════════════════════════════

/**
 * Extrae ubicaciones (puede ser multi-ciudad).
 * Soporta: "en Madrid", "Madrid y Barcelona", "Madrid, Valencia y Sevilla"
 */
function extractLocations(doc, text) {
  const found = new Set();

  // 0) Alias multi-ciudad (ej: "canarias" → ['Las Palmas', 'Tenerife'])
  for (const [alias, cities] of Object.entries(multiLocationAliases)) {
    const regex = new RegExp(`\\b${escapeRegex(alias)}\\b`, 'i');
    if (regex.test(text)) {
      cities.forEach(c => found.add(c));
    }
  }

  // 1) Buscar ciudades por NLP tags
  const matches = doc.match('#ColivingLocation');
  if (matches && matches.length > 0) {
    const words = matches.text().split(/\s+/);
    for (const w of words) {
      const mapped = findCity(w);
      if (mapped) found.add(mapped);
    }
  }

  // 2) Regex: buscar cualquier ciudad conocida en el texto
  for (const [key, value] of Object.entries(availableLocationsMap)) {
    // Multi-word keys
    if (key.includes(' ')) {
      if (text.includes(key)) found.add(value);
    } else {
      // Single word con word boundary
      const regex = new RegExp(`\\b${escapeRegex(key)}\\b`, 'i');
      if (regex.test(text)) found.add(value);
    }
  }

  // 3) Fuzzy match: buscar con Levenshtein ≤ 1
  const words = text.split(/[\s,;.]+/).filter(Boolean);
  for (const word of words) {
    if (word.length < 4) continue; // Evitar falsos positivos con palabras cortas
    for (const [key, value] of Object.entries(availableLocationsMap)) {
      if (key.includes(' ')) continue; // Solo single-word
      if (levenshtein(word, key) <= 1) {
        found.add(value);
      }
    }
  }

  return [...found];
}

/**
 * Extrae precio máximo.
 * Soporta: "600€", "hasta 700", "máximo 500 euros", "menos de 800", "por 650"
 */
function extractMaxPrice(text) {
  // Patrones con indicador explícito de precio (ES + EN)
  const patterns = [
    // ES: hasta/máximo/menos de X €
    /(?:hasta|máximo|maximo|menos\s+de|no\s+más\s+de|como\s+mucho|por)\s+(\d+)\s*(?:€|euros?|\$|£|dollars?|pounds?)?/i,
    // Número seguido de símbolo de moneda
    /(\d+)\s*(?:€|euros?|\$|dollars?|£|pounds?)\s*(?:al\s+mes|\/\s*mes|mensuales?|\/\s*month|per\s+month|a\s+month)?/i,
    // Símbolo antes del número (estilo anglosajón: $1500, £1200)
    /(?:\$|£)\s*(\d+)/i,
    // budget/presupuesto
    /(?:precio|budget|presupuesto)\s*(?:de|:)?\s*(\d+)/i,
    /(?:max|maximum|máximo|maximo)\s+(?:\$|£|€)?\s*(\d+)/i,
    // Número + moneda al final
    /(\d+)\s*(?:€|euros?|\$|dollars?|£|pounds?)\s*(?:máximo|maximo|max)/i,
  ];

  for (const pattern of patterns) {
    const match = text.match(pattern);
    if (match) {
      const value = parseInt(match[1], 10);
      if (value >= 50 && value <= 15000) return value;
    }
  }

  // Fallback: número grande (3+ dígitos) suelto
  const bigNumber = text.match(/\b(\d{3,})\b/);
  if (bigNumber) {
    const value = parseInt(bigNumber[1], 10);
    if (value >= 100 && value <= 15000) return value;
  }

  return null;
}

/**
 * Extrae duración máxima de estancia mínima.
 * Soporta: "3 meses", "corta estancia", "un mes", "medio año", "temporal"
 */
// ── Mapa de palabras numéricas en inglés ──
const numberWordsEnMap = {
  one: 1, two: 2, three: 3, four: 4, five: 5,
  six: 6, seven: 7, eight: 8, nine: 9,
  ten: 10, eleven: 11, twelve: 12,
  half: 6, // "half a year"
};

function parseNumberWordEn(word) {
  const lower = word.toLowerCase().trim();
  if (numberWordsEnMap[lower] !== undefined) return numberWordsEnMap[lower];
  const num = parseInt(lower, 10);
  return isNaN(num) ? undefined : num;
}

function extractStayDuration(doc, text) {
  // Patrones numéricos de meses (ES + EN)
  const monthPatterns = [
    /(\d+)\s*mes(?:es)?/i,
    /(?:para|de|por|durante)\s+(\d+)\s*mes(?:es)?/i,
    /estancia\s+(?:de\s+)?(\d+)\s*mes(?:es)?/i,
    /(\d+)\s*months?/i,
    /(?:for|during|about)\s+(\d+)\s*months?/i,
    /stay\s+(?:of\s+)?(\d+)\s*months?/i,
  ];

  for (const pattern of monthPatterns) {
    const match = text.match(pattern);
    if (match) {
      const months = parseInt(match[1], 10);
      if (months >= 1 && months <= 12) return months;
    }
  }

  // Patrones con palabras numéricas ES
  const wordPatternES = /(?:para|de|por|durante)\s+(un|una|dos|tres|cuatro|cinco|seis)\s+mes(?:es)?/i;
  const wordMatchES = text.match(wordPatternES);
  if (wordMatchES) {
    const months = parseNumberWord(wordMatchES[1]);
    if (months) return months;
  }

  // Patrones con palabras numéricas EN
  const wordPatternEN = /(?:for|during|about)\s+(one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)\s+months?/i;
  const wordMatchEN = text.match(wordPatternEN);
  if (wordMatchEN) {
    const months = parseNumberWordEn(wordMatchEN[1]);
    if (months) return months;
  }

  // Patrones cualitativos ES + EN
  if (/\b(corta\s+estancia|temporal|short\s+stay|corto\s+plazo|short[\s-]term)\b/i.test(text)) return 3;
  if (/\b(larga\s+estancia|long\s+stay|largo\s+plazo|long[\s-]term)\b/i.test(text)) return 12;
  if (/\bmedio\s+año\b/i.test(text)) return 6;
  if (/\b(un\s+año|one\s+year|a\s+year)\b/i.test(text)) return 12;
  if (/\b(semestre|semester|half\s+a\s+year)\b/i.test(text)) return 6;
  if (/\b(trimestre|quarter)\b/i.test(text)) return 3;

  return null;
}

/**
 * Extrae políticas: mascotas y parejas.
 */
function extractPolicies(doc, text) {
  const policies = { pets: false, couples: false };

  // Mascotas (ES + EN)
  if (matchAny(doc, text, [
    'mascotas', 'mascota', 'perro', 'perros', 'gato', 'gatos',
    'animal', 'animales', 'pets', 'pet', 'pet friendly', 'pet-friendly',
    'dog', 'dogs', 'cat', 'cats', 'animals', 'furry'
  ])) {
    policies.pets = true;
  }

  // Parejas (ES + EN)
  if (matchAny(doc, text, [
    'parejas', 'pareja', 'novio', 'novia', 'couples', 'couple',
    'con mi pareja', 'con mi novio', 'con mi novia',
    'ir con pareja', 'vivir en pareja',
    'partner', 'my partner', 'with my partner',
    'girlfriend', 'boyfriend', 'with partner', 'couple friendly'
  ])) {
    policies.couples = true;
  }

  return policies;
}

/**
 * Extrae servicios: internet, limpieza, todo incluido.
 */
function extractServices(doc, text) {
  const services = { internet: false, cleaning: false, allIncluded: false };

  // Internet / WiFi (ES + EN)
  if (matchAny(doc, text, [
    'wifi', 'internet', 'fibra', 'conexión',
    'broadband', 'high speed', 'high-speed', 'fibre', 'fiber',
    'fast wifi', 'fast internet'
  ])) {
    services.internet = true;
  }

  // Limpieza (ES + EN)
  if (matchAny(doc, text, [
    'limpieza', 'cleaning', 'servicio de limpieza',
    'cleaning service', 'housekeeping', 'maid service'
  ])) {
    services.cleaning = true;
  }

  // Todo incluido (ES + EN)
  if (matchAny(doc, text, [
    'todo incluido', 'gastos incluidos', 'all included', 'all inclusive',
    'suministros incluidos', 'bills included', 'todo incluído',
    'utilities included', 'everything included', 'all bills included',
    'all bills', 'inclusive', 'fully inclusive'
  ])) {
    services.allIncluded = true;
  }

  return services;
}

/**
 * Extrae número mínimo de baños.
 */
function extractBathrooms(doc, text) {
  const patterns = [
    /(\d+)\s*(?:baños|baño|bathroom|bathrooms)/i,
    /(?:baños|baño)\s*:?\s*(\d+)/i,
    /(?:con|mínimo|al\s+menos)\s+(\d+)\s*(?:baños|baño)/i,
    /(?:with|at\s+least|minimum|min)\s+(\d+)\s*(?:bathroom|bathrooms|bath|baths)/i,
    /(\d+)\s*(?:bath|baths)\b/i,
  ];

  for (const pattern of patterns) {
    const match = text.match(pattern);
    if (match) {
      const num = parseInt(match[1], 10);
      if (num >= 2 && num <= 5) return num;
    }
  }

  return null;
}

/**
 * Extrae tipo de alojamiento: building o apartment.
 */
function extractAccommodationType(doc, text) {
  const result = { building: false, apartment: false };

  if (matchAny(doc, text, [
    'edificio', 'residencia', 'building', 'residence',
    'residencia de estudiantes', 'student residence',
    'edificio coliving', 'coliving building', 'coliving space',
    'purpose built', 'purpose-built'
  ])) {
    result.building = true;
  }

  if (matchAny(doc, text, [
    'piso compartido', 'apartamento compartido', 'piso', 'apartment',
    'flat', 'shared apartment', 'shared flat',
    'house share', 'house sharing', 'hmo', 'room in a house',
    'shared house', 'flatshare', 'flat share'
  ])) {
    result.apartment = true;
  }

  return result;
}

/**
 * Detecta si el usuario busca algo específico para estudiantes.
 */
function extractStudentFilter(doc, text) {
  return matchAny(doc, text, [
    'estudiante', 'estudiantes', 'erasmus', 'universitario', 'universitarios',
    'student', 'students', 'residencia de estudiantes', 'student residence',
    'university', 'universidad',
    'college', 'uni', 'postgrad', 'postgraduate', 'grad student',
    'masters', 'master\'s', 'phd', 'exchange student'
  ]);
}

/**
 * Detecta si el usuario es nómada digital o trabaja en remoto.
 */
function extractNomadFilter(doc, text) {
  return matchAny(doc, text, [
    'nómada', 'nómadas', 'nomada', 'nomadas',
    'nómada digital', 'nómadas digitales',
    'digital nomad', 'digital nomads', 'nomad', 'nomads',
    'remote worker', 'remote workers', 'remote work',
    'freelancer', 'freelancers', 'trabajo remoto', 'teletrabajo',
    'trabaja en remoto', 'work remotely'
  ]);
}

/**
 * Extrae proveedores mencionados.
 */
function extractProviders(text) {
  const found = [];
  const lowerText = text.toLowerCase();

  // Ordenar keys por longitud descendente para que "urban campus" matchee antes que "urban"
  const sortedKeys = Object.keys(providerMap).sort((a, b) => b.length - a.length);

  for (const key of sortedKeys) {
    if (lowerText.includes(key)) {
      const id = providerMap[key];
      if (!found.includes(id)) {
        found.push(id);
      }
    }
  }

  return found;
}

// ═══════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════

function matchAny(doc, text, terms) {
  const lowerText = text.toLowerCase();
  for (const term of terms) {
    // Multi-word: contains check
    if (term.includes(' ')) {
      if (lowerText.includes(term.toLowerCase())) return true;
    } else {
      // Single word: word boundary regex
      const regex = new RegExp(`\\b${escapeRegex(term.toLowerCase())}\\b`, 'i');
      if (regex.test(lowerText)) return true;
    }
  }

  // Fallback con compromise
  const joined = terms.join('|');
  const match = doc.match(`(${joined})`);
  return match && match.length > 0;
}

function findCity(word) {
  const lower = word.toLowerCase().trim();
  if (availableLocationsMap[lower]) return availableLocationsMap[lower];
  // Fuzzy
  for (const [key, value] of Object.entries(availableLocationsMap)) {
    if (key.includes(' ')) continue;
    if (levenshtein(lower, key) <= 1) return value;
  }
  return null;
}

function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function cleanFilters(filters) {
  // Eliminar locations vacías
  if (filters.locations && filters.locations.length === 0) delete filters.locations;

  // Eliminar precio nulo
  if (filters.maxPrice === null) delete filters.maxPrice;

  // Eliminar duración nula
  if (filters.maxMinimumStay === null) delete filters.maxMinimumStay;

  // Eliminar baños nulo
  if (filters.minBathrooms === null) delete filters.minBathrooms;

  // Eliminar políticas si ambas false
  if (filters.policies && !filters.policies.pets && !filters.policies.couples) {
    delete filters.policies;
  }

  // Eliminar servicios si todos false
  if (filters.services && !filters.services.internet && !filters.services.cleaning && !filters.services.allIncluded) {
    delete filters.services;
  }

  // Eliminar accommodationType si ambas false
  if (filters.accommodationType && !filters.accommodationType.building && !filters.accommodationType.apartment) {
    delete filters.accommodationType;
  }

  // Eliminar forStudents si false
  if (!filters.forStudents) delete filters.forStudents;

  // Eliminar forNomads si false
  if (!filters.forNomads) delete filters.forNomads;

  // Eliminar providers vacíos
  if (filters.providers && filters.providers.length === 0) delete filters.providers;
}

/**
 * Genera una descripción legible de los filtros detectados.
 * @param {object} filters - Filtros detectados
 * @param {'es'|'en'} [lang='es'] - Idioma para las etiquetas
 */
export function describeFilters(filters, lang = 'es') {
  const en = lang === 'en';
  const parts = [];

  if (filters.locations?.length > 0) {
    parts.push({ type: 'location', label: filters.locations.join(', '), icon: 'map-pin' });
  }
  if (filters.maxPrice) {
    parts.push({ type: 'price', label: `Max ${filters.maxPrice}${en ? '/mo' : '€/mes'}`, icon: 'currency' });
  }
  if (filters.maxMinimumStay) {
    parts.push({ type: 'stay', label: `≤${filters.maxMinimumStay} ${en ? 'months' : 'meses'}`, icon: 'calendar' });
  }
  if (filters.policies?.pets) {
    parts.push({ type: 'policy', label: en ? 'Pets' : 'Mascotas', icon: 'pet' });
  }
  if (filters.policies?.couples) {
    parts.push({ type: 'policy', label: en ? 'Couples' : 'Parejas', icon: 'heart' });
  }
  if (filters.services?.internet) {
    parts.push({ type: 'service', label: 'WiFi', icon: 'wifi' });
  }
  if (filters.services?.cleaning) {
    parts.push({ type: 'service', label: en ? 'Cleaning' : 'Limpieza', icon: 'sparkles' });
  }
  if (filters.services?.allIncluded) {
    parts.push({ type: 'service', label: en ? 'All included' : 'Todo incluido', icon: 'check-all' });
  }
  if (filters.minBathrooms) {
    parts.push({ type: 'bathrooms', label: `${filters.minBathrooms}+ ${en ? 'bathrooms' : 'baños'}`, icon: 'bath' });
  }
  if (filters.accommodationType?.building) {
    parts.push({ type: 'accommodation', label: en ? 'Building' : 'Edificio', icon: 'building' });
  }
  if (filters.accommodationType?.apartment) {
    parts.push({ type: 'accommodation', label: en ? 'Shared apartment' : 'Piso compartido', icon: 'home' });
  }
  if (filters.forStudents) {
    parts.push({ type: 'audience', label: en ? 'Students' : 'Estudiantes', icon: 'academic' });
  }
  if (filters.forNomads) {
    parts.push({ type: 'audience', label: en ? 'Remote / Nomad' : 'Nómada digital', icon: 'globe' });
  }
  if (filters.providers?.length > 0) {
    parts.push({ type: 'provider', label: filters.providers.join(', '), icon: 'tag' });
  }
  if (filters._usedPreference?.length > 0) {
    parts.push({ type: 'preference', label: en ? 'Based on your profile' : 'Con tus preferencias', icon: 'user' });
  }

  return parts;
}

/**
 * Convierte filtros del parser al formato de query params
 * compatibles con la API searchProperties.
 */
export function filtersToSearchParams(filters) {
  const params = {
    contractType: 'coliving',
    includeMarketStats: 'false',
    pageSize: 3,
    page: 1,
    sortBy: 'date_desc',
  };

  if (filters.locations?.length === 1) {
    params.propertyLocation = filters.locations[0];
  } else if (filters.locations?.length > 1) {
    params.propertyLocations = filters.locations.join(',');
  }

  if (filters.maxPrice) params.maxRoomPrice = filters.maxPrice;
  if (filters.maxMinimumStay) params.maxMinimumStay = filters.maxMinimumStay;
  if (filters.minBathrooms) params.minBathrooms = filters.minBathrooms;
  if (filters.policies?.pets) params.allowsPets = 'yes';
  if (filters.policies?.couples) params.allowsCouples = 'yes';
  if (filters.services?.internet) params.servicesInternet = 'yes';
  if (filters.services?.cleaning) params.servicesCleaning = 'yes';
  if (filters.services?.allIncluded) params.servicesAllIncluded = 'yes';
  if (filters.forStudents) params.forStudents = 'yes';
  if (filters.forNomads) params.forNomads = 'yes';

  if (filters.accommodationType?.building && !filters.accommodationType?.apartment) {
    params.accommodationType = 'building';
  } else if (filters.accommodationType?.apartment && !filters.accommodationType?.building) {
    params.accommodationType = 'apartment';
  }

  if (filters.providers?.length > 0) {
    params.providers = filters.providers.join(',');
  }

  return params;
}

/**
 * Convierte filtros del parser al formato de query string
 * para redirigir a /encuentratucoliving con filtros aplicados.
 */
export function filtersToRouteQuery(filters) {
  const query = {};

  if (filters.locations?.length > 0) {
    query.locations = filters.locations.join(',');
  }
  if (filters.maxPrice) query.maxPrice = String(filters.maxPrice);
  if (filters.maxMinimumStay) query.maxMinimumStay = String(filters.maxMinimumStay);
  if (filters.minBathrooms) query.minBathrooms = String(filters.minBathrooms);
  if (filters.policies?.pets) query.allowsPets = 'yes';
  if (filters.policies?.couples) query.allowsCouples = 'yes';
  if (filters.services?.internet) query.servicesInternet = 'yes';
  if (filters.services?.cleaning) query.servicesCleaning = 'yes';
  if (filters.services?.allIncluded) query.servicesAllIncluded = 'yes';
  if (filters.forStudents) query.forStudents = 'yes';
  if (filters.forNomads) query.forNomads = 'yes';
  if (filters.accommodationType?.building) query.accBuilding = 'yes';
  if (filters.accommodationType?.apartment) query.accApartment = 'yes';
  if (filters.providers?.length > 0) query.providers = filters.providers.join(',');

  return query;
}
